import { SVGProps, Ref, forwardRef } from 'react';

export const EyeOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.332 7.998c0-1.333.667-2.666 2.666-2.666 2 0 2.666 1.333 2.666 2.666s-.666 2.666-2.666 2.666-2.666-1.333-2.666-2.666m1.4 0c0-.458.117-.767.259-.937.104-.124.344-.329 1.007-.329s.903.205 1.007.33c.142.17.26.478.26.936s-.118.767-.26.937c-.104.124-.344.33-1.007.33s-.903-.206-1.007-.33c-.142-.17-.259-.478-.259-.937"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2.5C3.5 2.5.333 6.625 0 8c.333 1.375 3.5 5.5 8 5.5s7.667-4.125 8-5.5c-.333-1.375-3.5-5.5-8-5.5m0 9.6c-1.811 0-3.416-.832-4.648-1.895a9.2 9.2 0 0 1-1.455-1.579A6 6 0 0 1 1.505 8a6 6 0 0 1 .392-.626 9.2 9.2 0 0 1 1.455-1.58C4.584 4.734 6.189 3.9 8 3.9s3.416.833 4.648 1.895a9.2 9.2 0 0 1 1.455 1.579c.18.254.308.465.392.626-.084.16-.211.372-.392.626a9.2 9.2 0 0 1-1.455 1.58C11.416 11.267 9.811 12.1 8 12.1"
                fill="currentColor"
            />
        </g>
    </svg>
));
EyeOutlinedSize16Glyph.displayName = 'EyeOutlinedSize16Glyph';
